import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import LoginForm from './../block/LoginForm'
import Breadcrumbs from './../block/Breadcrumbs'
import LkSidebar from './../block/LkSidebar'

import { Container, Button, Image } from 'react-bootstrap'

import styles from './../style/Lk.module.scss'

function OrderСancellation( { date, id, cancellation } ) {
  const now = Math.floor(Date.now() / 1000)
  if( ( now - date ) < 1800 ) {
    var differenceDate = new Date( ( now - date ) * 1000 )
    var diffMinutes = differenceDate.getUTCMinutes()
    var diffSeconds = differenceDate.getUTCSeconds()
    return (
      <Button onClick={() => cancellation( id )} className={styles.order_cancellation + ` text-white`} variatn={`dark`}>
        Отменить заказ
        <div className={styles.order_cancellation_sep}></div>
        {('00' + ( 30 - diffMinutes ) ).slice(-2)}:{('00' + ( 59 - diffSeconds ) ).slice(-2)}
      </Button>
    )
  }
  return (
    <></>
  )
}
OrderСancellation.propTypes = {
  date: PropTypes.string,
  id: PropTypes.number,
  cancellation: PropTypes.func
}

function FormatDate( { timestamp } ) {
  const date = new Date(timestamp * 1000)
  const monthNames = [
    'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
    'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
  ]
  const day = date.getDate()
  const month = monthNames[ date.getMonth() ]
  return (
    <> {day} {month}</>
  )
}
FormatDate.propTypes = {
  timestamp: PropTypes.number
}

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      count: 0,
      page: 1,
      current: [],
      old: [],
      timer: 0,
      cartCount: props.cart.reduce((total, item) => total + item.count, 0)
    }
  }

  formatPrice(price) {
    return this.priceFormat(price) + ' ₽'
  }

  priceFormat(price, delimiter = '', fraction = '') {
    if (!price && price !== 0) return 'Цена не указана'
    
    const numericPrice = typeof price === 'number' ? price : parseFloat(price)
    
    return numericPrice.toLocaleString('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }

  logOut() {
    const baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'logout'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        location.reload()
      }
    })
  }

  loadProducts = () => {
    const baseURL = window.location.protocol + "//" + window.location.hostname,
    main = this

    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'load_orders',
      'page': this.state.page
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      main.setState({
        count: response.data.count,
        page: response.data.page,
        current: response.data.current,
        old: response.data.old
      })
    })
  }

  cancellation = ( id ) => {
    window.console.log( id )
    const baseURL = window.location.protocol + "//" + window.location.hostname,
    main = this

    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'cancellation_order',
      'id': id
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        main.loadProducts()
      } else {
        alert( `Ошибка: ` + response.data.massage )
      }
    })
  }

  repeatOrder = ( id ) => {
    const baseURL = window.location.protocol + "//" + window.location.hostname,
    main = this

    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'repeat_order',
      'id': id
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        const { data, addTocart, clearCart } = main.props
        clearCart( () => {
          response.data?.array.map( ( elm ) => {
            addTocart( elm )
          })
          setTimeout( () => {
            window.location.href = data?.page_data?.link_cart
          }, 1000)
        } )
      } else {
        alert( `Ошибка: ` + response.data.massage )
      }
    })
  }

  order_list_item( elm, i ) {
    if(elm?.type == 'legal') return (
      <div key={i} className={styles.order_list_item_content_legal}>
        <div className={styles.order_list_item_content_legal_line_1}>
          <div>
            <div className={styles.order_list_item_content_legal_line_1_title}>{elm?.status}</div>
            <div className={styles.order_list_item_content_legal_line_1_text}>Способ доставки: {elm?.delivery || 'Не выбран'}</div>
          </div>
          <div>
            <div className={styles.order_list_item_content_legal_line_1_title}>Организация</div>
            <div className={styles.order_list_item_content_legal_line_1_text}>{elm?.company || ` - `}</div>
          </div>
          <div>
            <div className={styles.order_list_item_content_legal_line_1_title}>
              Заказ от
              <FormatDate timestamp={elm?.createdon} />
            </div>
            <div className={styles.order_list_item_content_legal_line_1_text}>
              №{elm?.num}
            </div>
          </div>
        </div>
        <div className={styles.order_list_item_content_legal_line_2}>
          <div>
            <div className={styles.order_list_item_content_legal_line_2_text}>
              {elm?.pagetitle}<br />
              <span>{elm?.longtitle}</span>
            </div>
            <div className={styles.order_list_item_content_legal_line_2_text}>
              Количество упаковок {this.priceFormat(elm?.price * elm?.upakovka)} ₽ / уп<br />
              <span>{elm?.count / elm?.upakovka} упаковки</span>
            </div>
          </div>
          <div>
            <div className={styles.order_list_item_content_legal_line_2_text}>
              <div className={styles.order_list_item_content_legal_line_2_price_mob}><div>Полная стоимость</div> <div>{this.priceFormat(elm?.cost)} ₽</div></div><br />
              <span>включая НДС</span>
            </div>
            <Button onClick={() => this.repeatOrder( elm?.id )} className={styles.order_list_item_content_legal_line_2_btn} variant="primary">Повторить заказ</Button>
          </div>
          <div>
            <div className={styles.order_list_item_content_legal_line_2_price}>{this.priceFormat(elm?.cost)} ₽</div>
            <Button onClick={() => this.printOrder(elm)}  className={styles.order_list_item_content_legal_line_2_btn2} variant="light">Распечатать</Button>
          </div>
        </div>
      </div>
    )
    
    return (
      <div key={i} className={styles.order_list_item}>
        <div className={styles.order_list_item_content}>
          <Image alt="Заказ" className={styles.order_list_item_image} src={elm.image} width={155} height={155} />
          <div className={styles.order_list_item_text}>
            <div className={styles.order_list_item_text_h}>
              <div>
                <div className={styles.order_list_item_status_b}>{elm.status}</div>
                <div className={styles.order_list_item_delivery}>Способ доставки: {elm.delivery}</div>
                <div className={styles.order_list_item_delivery}>Сумма заказа: {this.priceFormat(elm.cost)} ₽</div>
              </div>
              <div className='text-end d-none d-lg-block'>
                {elm.createdon &&
                  <div className={styles.order_list_item_status}>
                    Заказ от
                    <FormatDate timestamp={elm.createdon} />
                  </div>
                }
                <div className={styles.order_list_item_delivery}>№{elm.num}</div>
              </div>
            </div>
            <div className={styles.order_list_sep}></div>
            <div className='d-flex align-items-start justify-content-between'>
              <Image alt="Заказ" className="d-lg-none me-2" src={elm.image} width={96} height={96} />
              <div style={{ flex: 1 }}>
                {elm?.products.map((product) => (
                  <>
                    <div className='w-100 d-flex justify-content-between'>
                      <div>
                        <div className={styles.order_list_article}>Арт. {product?.article}</div>
                        <div className={styles.order_list_name}>{product?.name}</div>
                      </div>
                      <div className={styles.order_list_cost}>{product.count}шт. х {this.priceFormat(product.price)} = {this.priceFormat(product.cost)} ₽</div>
                    </div>
                    <div className={styles.order_list_article + ` mb-0`}>{product?.manufacturer}</div>
                    <div className={styles.order_list_cost_mob}>{product.count}шт. х {this.priceFormat(product.price)} = {this.priceFormat(product.cost)} ₽</div>
                  </>
                ))}
                <div className='d-lg-none'>
                  {elm.createdon &&
                    <div className={styles.order_list_item_status}>
                      Заказ от
                      <FormatDate timestamp={elm.createdon} />
                    </div>
                  }
                  <div className={styles.order_list_item_delivery}>№{elm.num}</div>
                </div>
              </div>
            </div>
            <div className='d-flex'>
              {elm?.status_id == 1 && (elm?.payment_id == 1 || elm?.payment_id == 7) &&
                <Button target="_blank" href={`/getpaymentlink/${elm?.id}`} className={styles.order_cancellation + ` text-white me-2`} variatn={`dark`}>
                  Оплатить заказ
                </Button>
              }
              {elm?.status_id != 1 &&
                <Button onClick={() => this.repeatOrder( elm?.id )} className={styles.order_cancellation + ` text-white me-2`} variant="dark">Повторить заказ</Button>
              }
              <OrderСancellation
                date={elm.createdon}
                id={elm.id}
                cancellation={this.cancellation}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  printOrder = (order) => {
    const { 
      num, 
      createdon, 
      status, 
      delivery, 
      company, 
      cost, 
      properties 
    } = order;

    const { nalog } = properties || {};
    const products = order.products || [];

    // Форматируем дату
    const orderDate = new Date(createdon * 1000).toLocaleDateString('ru-RU');
    
    // Создаем содержимое для печати
    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Заказ StomaHelp</title>
        <meta charset="utf-8">
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          .print-header { text-align: center; margin-bottom: 20px; }
          .print-section { margin-bottom: 15px; }
          .print-section h3 { margin-bottom: 5px; color: #333; }
          .print-table { width: 100%; border-collapse: collapse; margin: 15px 0; }
          .print-table th, .print-table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          .print-table th { background-color: #f5f5f5; }
          .print-total { font-weight: bold; margin-top: 10px; }
          @media print {
            body { margin: 0; }
            .no-print { display: none; }
          }
        </style>
      </head>
      <body>
        <div class="print-header">
          <h1>Заказ StomaHelp</h1>
          <p>Номер заказа: ${num}</p>
          <p>Дата: ${orderDate}</p>
        </div>

        <div class="print-section">
          <h3>Информация о заказе</h3>
          <p>Статус: ${status}</p>
          <p>Способ доставки: ${delivery}</p>
          ${company ? `<p>Компания: ${company}</p>` : ''}
        </div>

        ${properties?.inn ? `
          <div class="print-section">
            <h3>Реквизиты</h3>
            <p>ИНН: ${properties.inn}</p>
            ${properties.company ? `<p>Компания: ${properties.company}</p>` : ''}
          </div>
        ` : ''}

        <div class="print-section">
          <h3>Система налогообложения</h3>
          <p>${nalog === 'ОСН' ? 'ОСН (общая система налогообложения)' : 'УСН (упрощенная система налогообложения)'}</p>
        </div>

        <div class="print-section">
          <h3>Товары</h3>
          <table class="print-table">
            <thead>
              <tr>
                <th>Наименование</th>
                <th>Количество</th>
                <th>Цена за ед.</th>
                <th>Сумма</th>
              </tr>
            </thead>
            <tbody>
              ${products.map(product => `
                <tr>
                  <td>${product.name}</td>
                  <td>${product.count} шт.</td>
                  <td>${this.priceFormat(product.price)} ₽</td>
                  <td>${this.priceFormat(product.price * product.count)} ₽</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>

        <div class="print-section">
          <h3>Итоги</h3>
          <p>Общая стоимость: ${this.priceFormat(cost)} ₽</p>
          ${nalog === 'ОСН' ? `
            <p>Сумма НДС (20%): ${this.priceFormat(cost * 0.2)} ₽</p>
            <p class="print-total">Итого, включая НДС: ${this.priceFormat(cost)} ₽</p>
          ` : `
            <p class="print-total">Итого: ${this.priceFormat(cost)} ₽</p>
          `}
        </div>

        <div class="no-print" style="margin-top: 20px; text-align: center;">
          <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">
            Печать
          </button>
          <button onclick="window.close()" style="padding: 10px 20px; margin-left: 10px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">
            Закрыть
          </button>
        </div>
      </body>
      </html>
    `;

    // Открываем новое окно для печати
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    
    // Даем время на загрузку контента перед печатью
    printWindow.onload = function() {
      printWindow.focus();
      // Автоматически запускаем печать
      printWindow.print();
    };
  }

  componentDidMount() {
    this.loadProducts()

    const main = this
    setInterval(() => {
      const { timer } = main.state
      main.setState({
        timer: timer + 1
      })
    }, 1000)

  }

  render() {

    const { ajax_data, data, loading_user, authorized, user_profile_type } = this.props,
    { current, old, cartCount } = this.state

    if (loading_user) {
      return (
        <>
          <div className='w-100 d-flex align-items-center' style={{ flex: 1 }}>
            <div className="container text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Загрузка...</span>
              </div>
              <p className="mt-3">Загрузка данных...</p>
            </div>
          </div>
        </>
      )
    }

    return (
      <div className='w-100' style={{ flex: 1 }}>
        {ajax_data != null &&
          <>
            {authorized ?
              <>
                <Breadcrumbs
                  items={ajax_data.breadcrumbs}
                />
                <div className={styles.lk_page}>
                  <Container className={styles.container}>
                    <h1>{ajax_data.pagetitle}</h1>
                    <div className={styles.lk_page_block}>
                      <LkSidebar 
                        data={data} 
                        cartCount={cartCount} 
                        logOut={() => this.logOut()} 
                        active={3}
                        user_profile_type={user_profile_type}
                      />

                      <div className={styles.lk_page_block_right}>
                        <div className={styles.order_list}>
                          {current.length > 0 &&
                            <>
                              {current.sort((a, b) => a.id < b.id ? 1 : -1).map(( elm, i ) => {
                                return(
                                  <>
                                    {this.order_list_item( elm, i )}
                                  </>
                                )
                              })}
                            </>
                          }
                          {old.length > 0 &&
                            <>
                              {old.sort((a, b) => a.id < b.id ? 1 : -1).map(( elm, i ) => {
                                return(
                                  <>
                                    {this.order_list_item( elm, i )}
                                  </>
                                )
                              })}
                            </>
                          }
                          {current.length == 0 && old.length == 0 &&
                            <div style={{ textAlign: `center`, margin: `30px 0px` }}>Перейдите в <a href="/katalog/">каталог</a> для выбора товаров</div>
                          }
                        </div>
                      </div>
                    </div>
                  </Container>
                </div>
              </>
            :
              <>
                <Breadcrumbs
                  items={ajax_data.breadcrumbs}
                />
                <LoginForm
                  ajax_data={ajax_data}
                  user_profile_type={user_profile_type}
                />
              </>
            }
          </>
        }
      </div>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  changeFavorite: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  clearCart: PropTypes.func,
  user_profile_type: PropTypes.string,
  authorized: PropTypes.bool,
  loading_user: PropTypes.bool
}